import React, { useState, useEffect } from 'react';
import { Routes, Route, Link, useNavigate, useLocation } from 'react-router-dom';
import api from '../../api';
import { useAuth } from '../../context/AuthContext';
import AdminDashboard from './AdminDashboard';
import AdminProducts from './AdminProducts';
import AdminCategories from './AdminCategories';
import AdminUsers from './AdminUsers';
import AdminOrders from './AdminOrders';
import AdminMessages from './AdminMessages';
import AdminSettings from './AdminSettings';
import './Admin.css';

export default function Admin() {
  const { user, isAdmin, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [stats, setStats] = useState({});

  useEffect(() => {
    if (!user) { navigate('/login'); return; }
    if (!isAdmin) { navigate('/'); return; }
    api.get('/admin/stats').then(r => setStats(r.data)).catch(() => {});
  }, [user, isAdmin, navigate, location]);

  const handleLogout = async () => { await logout(); navigate('/'); };

  const navItems = [
    { path: '/admin', label: 'Dashboard', icon: '◉', exact: true },
    { path: '/admin/products', label: 'Products', icon: '◈', badge: stats.totalProducts },
    { path: '/admin/categories', label: 'Categories', icon: '◧' },
    { path: '/admin/users', label: 'Users', icon: '◎', badge: stats.pendingUsers || null, badgeType: 'warning' },
    { path: '/admin/orders', label: 'Orders', icon: '◫', badge: stats.pendingOrders || null, badgeType: 'warning' },
    { path: '/admin/messages', label: 'Messages', icon: '◻', badge: stats.unreadMessages || null, badgeType: 'warning' },
    { path: '/admin/settings', label: 'Settings', icon: '◌' },
  ];

  const isActive = (path, exact) => exact ? location.pathname === path : location.pathname.startsWith(path);

  if (!user || !isAdmin) return null;

  return (
    <div className="admin-layout">
      <aside className="admin-sidebar">
        <div className="admin-brand">
          <Link to="/" className="admin-logo">ElevenNorth<span> &amp; Co.</span></Link>
          <span className="admin-role">Admin Panel</span>
        </div>
        <nav className="admin-nav">
          {navItems.map(item => (
            <Link key={item.path} to={item.path} className={`admin-nav-item ${isActive(item.path, item.exact) ? 'active' : ''}`}>
              <span className="admin-nav-icon">{item.icon}</span>
              <span className="admin-nav-label">{item.label}</span>
              {item.badge > 0 && <span className={`admin-nav-badge ${item.badgeType === 'warning' ? 'badge-warning' : 'badge-gray'}`}>{item.badge}</span>}
            </Link>
          ))}
        </nav>
        <div className="admin-sidebar-footer">
          <Link to="/catalogue" className="admin-nav-item" style={{opacity:0.6}}>
            <span className="admin-nav-icon">↗</span>
            <span className="admin-nav-label">View Website</span>
          </Link>
          <button onClick={handleLogout} className="admin-nav-item admin-logout-btn">
            <span className="admin-nav-icon">⊗</span>
            <span className="admin-nav-label">Sign Out</span>
          </button>
        </div>
      </aside>

      <main className="admin-main">
        <Routes>
          <Route index element={<AdminDashboard stats={stats} />} />
          <Route path="products/*" element={<AdminProducts />} />
          <Route path="categories" element={<AdminCategories />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="orders" element={<AdminOrders />} />
          <Route path="messages" element={<AdminMessages />} />
          <Route path="settings" element={<AdminSettings />} />
        </Routes>
      </main>
    </div>
  );
}
